import client from './client';

export const analyticsApi = {
  // Overview
  getOverview: (days = 30) => client.get(`/analytics/overview?days=${days}`),

  // Cost tracking
  getCosts: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    return client.get(`/analytics/costs?${queryParams.toString()}`);
  },

  getCostsSummary: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.period) queryParams.append('period', params.period);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    return client.get(`/analytics/costs/summary?${queryParams.toString()}`);
  },

  // OpenAI logs
  getLogs: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.model) queryParams.append('model', params.model);
    if (params.method) queryParams.append('method', params.method);
    if (params.requestType) queryParams.append('requestType', params.requestType);
    if (params.success !== undefined) queryParams.append('success', params.success);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.search) queryParams.append('search', params.search);
    return client.get(`/analytics/logs?${queryParams.toString()}`);
  },

  getLogsStats: (days = 7) => client.get(`/analytics/logs/stats?days=${days}`),

  getFilterOptions: () => client.get('/analytics/logs/filters'),

  // Rate limits
  getRateLimits: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.limitType) queryParams.append('limitType', params.limitType);
    if (params.blocked !== undefined) queryParams.append('blocked', params.blocked);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    return client.get(`/analytics/rate-limits?${queryParams.toString()}`);
  },

  getRateLimitsSummary: (days = 7) => client.get(`/analytics/rate-limits/summary?days=${days}`),

  // Audios
  getAudios: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.language) queryParams.append('language', params.language);
    if (params.hasTranscript !== undefined) queryParams.append('hasTranscript', params.hasTranscript);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.search) queryParams.append('search', params.search);
    return client.get(`/analytics/audios?${queryParams.toString()}`);
  },

  getAudiosSummary: (days = 30) => client.get(`/analytics/audios/summary?days=${days}`),

  getAudioFilterOptions: () => client.get('/analytics/audios/filters')
};
